import { IServiceCnsProjectionRunParams } from '@shared/api';
import { Api } from '../../Api';

export class Jobs {
    private static _basePath = '/Jobs';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${Jobs._basePath}`;
        return {
            async postCnsProjectionRun({ date }: IServiceCnsProjectionRunParams) {
                const path = '/cnsProjection/run';
                return await Api.post<void>({
                    path: `${basePath}${path}/?date=${date}`,
                });
            },
            async postOwAssetsRun({ date }: IServiceCnsProjectionRunParams) {
                const path = '/owAssets/run';
                return await Api.post<void>({
                    path: `${basePath}${path}/?date=${date}`,
                });
            },
            async postDtcApibalStart() {
                const path = '/dtc/apibal/start';
                return await Api.post<void>({
                    path: `${basePath}${path}`,
                });
            },
            async postDtccTradeSummaryRun({ date }: IServiceCnsProjectionRunParams) {
                const path = '/dtccTradeSummary/run';
                return await Api.post<void>({
                    path: `${basePath}${path}/?date=${date}`,
                });
            },
            async postCnsAssetsStart({ date }: IServiceCnsProjectionRunParams) {
                const path = '/cnsAssets/run';
                return await Api.post<void>({
                    path: `${basePath}${path}/?date=${date}`,
                });
            },
        };
    }
}
